export class ZipcodeDataModel {

    zipcodeModel = {
        id: null,
        assignedTenantId: null,
        assignedTenantCode: ''
    };

    zipCodeFormPayload = {
        zipCodeId: '',
        zipCode: '',
        city: '',
        province: '',
        countryId: 0,
        tenantId: 0
    }
}
